import Comment from './Comment';
import CommentActionBtn from './CommentActionBtn';

export default class CommentHandler {

  constructor() {

    /**
     * selectors
     * @type {{comments: string}}
     */
    this.SELECTORS = {
      comments: '.js-comment',
      commentActionBtn: '.js-comment-action-btn',
      newCommentActionBtn: '.js-comment-action-btn:not(.is-init)',
      socializeItem: '.js-socialize-item',
      replyFrom: '#replyForm',
      writeForm: '#writeComment form',
    };

    /**
     * comments of page
     */
    this.COMMENTS = Array.from($(this.SELECTORS.comments));

    /**
     * comment action btn
     */
    this.COMMENT_ACTION_BTNS = Array.from($(this.SELECTORS.commentActionBtn));

    /**
     * reply form for comments
     * @type {jQuery|HTMLElement}
     */
    this.REPLY_FORM = $(this.SELECTORS.replyFrom);

    /**
     * comments form
     * @type {jQuery|HTMLElement}
     */
    this.COMMENT_FORM = $(this.SELECTORS.writeForm);

    /**
     * constant for the EVENT_TRIGGER
     * @type {string}
     */
    this.EVENT_TRIGGER = 'lin-socialize:';

    /**
     * event for update
     */
    this.UPDATE_EVENT = new CustomEvent(
        this.EVENT_TRIGGER + 'comments:updated', {
          bubbles: true,
        },
    );

    this.initComponents().then(_ => {
      this.registerHooks();
    });

  }

  /**
   * Initialize components for CommentHandler
   * @private
   * @example
   * this.initComponents()
   */
  initComponents() {
    let _this = this;
    return new Promise(resolve => {
      _this.cloneCommentFormToReplyForm().then(_ => {

        if (_this.COMMENTS.length > 0) {
          let comments = [];
          _this.COMMENTS.forEach(comment => {
            comments.push(new Comment($(comment)));
          });
          _this.COMMETNS = comments;
        }

        if (_this.COMMENT_ACTION_BTNS.length > 0) {
          let commentActionBtns = [];
          _this.COMMENT_ACTION_BTNS.forEach(commentActionBtn => {
            commentActionBtns.push(new CommentActionBtn($(commentActionBtn)));
          });
          _this.COMMENT_ACTION_BTNS = commentActionBtns;
        }

      });
      resolve();
    });

  }

  /**
   * clone the comment form to use it as reply form
   * @return {Promise}
   */
  cloneCommentFormToReplyForm() {
    let _this = this;
    return new Promise(resolve => {
      let $replyForm = _this.COMMENT_FORM.clone();
      $replyForm.hide();
      $replyForm.attr('id', 'replyForm');
      $replyForm.addClass('comment-reply comment-reply-form');
      let $textarea = $replyForm.find('.textarea');
      $textarea.attr('placeholder', $textarea.attr('data-reply-text'));
      $replyForm.appendTo($('body'));
      resolve();
    });
  }

  /**
   * Register events for CommentHandler
   * @private
   * @example
   * this.registerHooks()
   */
  registerHooks() {
    let _this = this;
    let $body = $('body');

    $body.on('lin-base:news:click:load-more', e => {
      _this.updateCommentActonBtnsArray();
    });

    $body.on('lin-base:news:submit:filter-form', e => {
      _this.updateCommentActonBtnsArray();
    });

  }

  /**
   * update array of comment action buttons
   */
  updateCommentActonBtnsArray() {
    let _this = this;
    $(_this.SELECTORS.newCommentActionBtn).each((index, actionBtn) => {
      _this.COMMENT_ACTION_BTNS.push(new CommentActionBtn($(actionBtn)));
    });
    _this.triggerEvent(_this.UPDATE_EVENT);
  }

  /**
   * trigger specific event
   * @param event CustomEvent
   */
  triggerEvent(event) {
    document.querySelector('body').dispatchEvent(event);
  }

}